// extracted by mini-css-extract-plugin
export default {"extraContainer":"KybTitle_extraContainer__O6RV0"};